import React from 'react';
import { isEmpty, cloneDeep, filter } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { moveAndPushDown } from '../../common/collection';

import ACButton from '../../atoms/ACButton';
import ACCategory from '../../atoms/ACCategory';
import AdditionalFun from '../../molecules/sparks/AdditionalFun';

import styles from './AdditionalFuns.module.scss';
import SetAdditionalFun from './SetAdditionalFun';

const dummyCategoryName = 'Unsorted';
const addNewCategorylabel = 'Add new category';
export default class AdditionalFuns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
      isModalOpen: false,
      additionalFun: {},
    };
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;

    if (!isEmpty(media) && media !== prevProps.media) {
      const { additionalFun = {} } = cloneDeep(this.state);
      const { url = '' } = media;
      additionalFun.media['url'] = url;
      this.setState({ additionalFun });
    }
  }

  onOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  onSelectAdditionalFun = (additionalFun) => {
    const { media, medias = [] } = additionalFun;
    additionalFun.media = isEmpty(media) ? medias[medias.length - 1] : media;

    this.setState({ additionalFun });

    this.onOpenModal();
  };

  onChangeAdditionalFun = (name, value) => {
    const { additionalFun = {} } = cloneDeep(this.state);
    additionalFun[name] = value;
    this.setState({ additionalFun });
  };

  onDeleteAdditionalFun = (index) => {
    const { additionalFuns = [], onSaveAdditionalFunsFunc } = cloneDeep(this.props);

    if (index >= 0) {
      additionalFuns.splice(index, 1);
    }

    onSaveAdditionalFunsFunc(additionalFuns);
    this.onCloseModal();
  };

  onClearAdditionalFunMedia = () => {
    const { additionalFun = {} } = cloneDeep(this.state);
    delete additionalFun.media;
    delete additionalFun.medias;
    this.setState({ additionalFun });
  };

  onSaveAdditionalFun = () => {
    let { additionalFun = {} } = cloneDeep(this.state);
    const { additionalFuns = [], onSaveAdditionalFunsFunc } = cloneDeep(this.props);

    additionalFun = this.getAdditionalFunWithMedias(additionalFun);

    const { index = -1 } = additionalFun;
    const parsedIndex = parseInt(index.toString());
    if (isEmpty(additionalFun)) return null;

    delete additionalFun.id;
    if (parsedIndex >= 0) {
      additionalFuns[parsedIndex] = additionalFun;
    } else {
      additionalFuns.push(additionalFun);
    }

    onSaveAdditionalFunsFunc(additionalFuns);
    this.onCloseModal();
  };

  getAdditionalFunWithMedias(additionalFun) {
    const { media = {}, medias = [] } = additionalFun;

    if (isEmpty(medias)) {
      if (!isEmpty(media)) medias.push(cloneDeep(media));
    } else {
      const lastMedia = medias[medias.length - 1] || { url: '' };
      if (!isEmpty(media) && media.url !== lastMedia.url) {
        medias.push(cloneDeep(media));
      }
    }
    delete additionalFun.media;
    additionalFun.medias = medias;

    return additionalFun;
  }

  onAddAdditionalFun = () => {
    const additionalFun = { id: -1 };
    this.setState({ additionalFun });
    this.onOpenModal();
  };

  highlightDestination = (highlightThisIndex) => {
    this.setState({
      highlight: highlightThisIndex,
    });
  };

  onSwapComplete = (from, to) => {
    this.setState({ highlight: -1 });
    const { additionalFuns = [], onSaveAdditionalFunsFunc } = this.props;
    const fromCategory = additionalFuns[from].category || '';
    const toCategory = additionalFuns[to].category || '';

    if (fromCategory !== toCategory) {
      alert('Swap can only proceed within categories');
      return;
    }

    const fromInt = parseInt(from.toString());
    const toInt = parseInt(to.toString());
    onSaveAdditionalFunsFunc(moveAndPushDown(additionalFuns, fromInt, toInt));
  };

  onUpdateCategoryName = (fromName, toName) => {
    const { additionalFuns = [], onSaveAdditionalFunsFunc } = cloneDeep(this.props);

    // Check if the AdditionalFuns are not categorized. If so, just put all the ones against new category.
    if (fromName.toUpperCase() === dummyCategoryName.toUpperCase()) {
      const updatedAdditionalFuns = cloneDeep(
        filter(additionalFuns, (additionalFun) => {
          if (isEmpty(additionalFun.category)) {
            return (additionalFun.category = toName);
          } else return additionalFun;
        })
      );

      onSaveAdditionalFunsFunc(updatedAdditionalFuns);
    } else {
      const updatedAdditionalFuns = cloneDeep(
        filter(additionalFuns, (additionalFun) => {
          if (additionalFun.category === fromName) {
            return (additionalFun.category = toName);
          } else return additionalFun;
        })
      );
      onSaveAdditionalFunsFunc(updatedAdditionalFuns);
    }
  };

  onAddNewCategory = (fromName, toName) => {
    if (toName === addNewCategorylabel || isEmpty(toName)) return null;

    const { additionalFuns, onSaveAdditionalFunsFunc } = this.props;
    const additionalFun = {
      category: toName,
      name: 'Name for ' + toName,
    };
    additionalFuns.push(additionalFun);
    onSaveAdditionalFunsFunc(additionalFuns);
  };

  getCategories() {
    let categories = [];
    const { additionalFuns = [] } = this.props;

    if (!isEmpty(additionalFuns)) {
      additionalFuns.forEach((additionalFun) => {
        const { category = dummyCategoryName } = additionalFun;
        const index = categories.findIndex((cat) => cat === category);
        if (index < 0) {
          categories.push(category);
        }
      });
    }

    return categories;
  }

  renderAddNewCategory() {
    const { sparkId = '' } = this.props;

    return (
      <ACCategory
        key={[sparkId, 'new-category'].join('_')}
        label={addNewCategorylabel}
        onUpdateTextFunc={this.onAddNewCategory}
      />
    );
  }

  renderAdditionalFunCategories() {
    const { additionalFuns = [] } = this.props;
    if (isEmpty(additionalFuns)) return <div />;
    const categories = this.getCategories();
    const { highlight } = cloneDeep(this.state);

    // Attach an order to help with swapping.
    additionalFuns.forEach((additionalFun, index) => {
      additionalFun.index = index;
    });

    return categories.map((category) => {
      let filteredAdditionalFuns = [];
      if (category === dummyCategoryName) {
        filteredAdditionalFuns = filter(additionalFuns, (additionalFun) => {
          return isEmpty(additionalFun.category);
        });
      } else {
        filteredAdditionalFuns = filter(additionalFuns, { category: category });
      }

      return (
        <div key={`category-${category}`}>
          <ACCategory label={category} onUpdateTextFunc={this.onUpdateCategoryName} />
          {filteredAdditionalFuns.map((additionalFun) => {
            return (
              <AdditionalFun
                key={`additional-fun-${additionalFun.index}`}
                additionalFun={additionalFun}
                onSwapFunc={this.onSwapComplete}
                highlight={highlight}
                highlightDestinationFunc={this.highlightDestination}
                onClickAdditionalFunFunc={this.onSelectAdditionalFun}
              />
            );
          })}
        </div>
      );
    });
  }

  render() {
    const { isModalOpen = false, additionalFun = {} } = cloneDeep(this.state);
    const { uploadMediaFunc } = this.props;
    const categories = this.getCategories();
    return (
      <div>
        <div className={styles.title}>
          Additional Fun
          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddAdditionalFun}
          />
        </div>
        {this.renderAdditionalFunCategories()}
        {this.renderAddNewCategory()}
        <SetAdditionalFun
          additionalFun={additionalFun}
          categories={categories}
          dummyCategoryName={dummyCategoryName}
          isModalOpen={isModalOpen}
          onCloseFunc={this.onCloseModal}
          onChangeAdditionalFunFunc={this.onChangeAdditionalFun}
          onSaveAdditionalFunFunc={this.onSaveAdditionalFun}
          uploadMediaFunc={uploadMediaFunc}
          onDeleteAdditionalFunFunc={this.onDeleteAdditionalFun}
          onClearAdditionalFunMediaFunc={this.onClearAdditionalFunMedia}
        />
      </div>
    );
  }
}
